import classNames from "classnames"
import React, { useContext } from "react"
import PropTypes from "prop-types"

import SmartLink from "../../../layout/SmartLink/SmartLink"
import SingleGeoContext from "../../../../contexts/single_geo"
import CareTypeContext from "../../../../contexts/care_type"
import { InlineText, SubTitle } from "../../../Typography/Typography"
import Separator from "../../../Separator/Separator"

import {
  bulletedList as bulletedListStyle,
  careNeedsLink,
  careTypeSpecificLinks,
  listItem,
  mainContent,
} from "./styles.module.scss"
import AgnosticLink from "./AgnosticLink"
import CareHomeLink from "./CareHomeLink"
import HomeCareLink from "./HomeCareLink"

const CareTypeSpecificLinks = ({ bulletedList }) => {
  const { totalHomeCareCount, totalCareHomeCount } = useContext(
    SingleGeoContext,
  )
  const { careType } = useContext(CareTypeContext)

  const careNeedsAssessmentPath =
    "https://www.caresourcer.com/caresupport/understanding-care/care-needs-assessment"

  return totalHomeCareCount > 0 || totalCareHomeCount > 0 ? (
    <ul
      className={classNames(careTypeSpecificLinks, {
        [bulletedListStyle]: bulletedList,
      })}
    >
      {careType !== "care_home" && <CareHomeLink />}

      {careType !== "home_care" && <HomeCareLink careType={careType} />}

      {!!careType && <AgnosticLink />}

      <li className={classNames(listItem, careNeedsLink)}>
        <Separator />
        <div className={mainContent}>
          <SubTitle>Unsure what care is needed?</SubTitle>
          <SmartLink
            to={careNeedsAssessmentPath}
            chevron
            clickEvent={{
              name:
                "SEO - Filtered Directory - Care Type Changed - Care Needs Assessment Clicked",
            }}
          >
            <InlineText brand>Read about a care needs assessment</InlineText>
          </SmartLink>
        </div>
      </li>
    </ul>
  ) : null
}

CareTypeSpecificLinks.propTypes = {
  bulletedList: PropTypes.bool,
}

CareTypeSpecificLinks.defaultProps = {
  bulletedList: false,
}

export default CareTypeSpecificLinks
